import React from 'react';
import { T } from '../TopBar';

const MONO = 'JetBrains Mono,monospace';

const STACK = [
  {
    name: 'Kaggle',
    eyebrow: 'DATASETS',
    accent: '#22d3ee',
    icon: '◉',
    blurb: 'Pull in benchmark datasets, competition tables, and raw training material.',
    points: ['Public datasets', 'Community benchmarks', 'Data discovery'],
  },
  {
    name: 'Hugging Face',
    eyebrow: 'MODELS',
    accent: '#fbbf24',
    icon: '⬢',
    blurb: 'Pick pretrained models, embeddings, and open model building blocks.',
    points: ['Model hub', 'Inference assets', 'Reusable checkpoints'],
  },
  {
    name: 'Jorvex',
    eyebrow: 'ANALYSIS + EXPERIMENTS',
    accent: '#4ade80',
    icon: '✦',
    blurb: 'Turn datasets into structured analysis, apply ML/DL experiments, reports, and saved workflows.',
    points: ['Auto EDA', 'ML and DL experiments', 'Reports, DAGs, saved workspaces'],
  },
];

function StackCard({ item, featured = false }) {
  return (
    <div style={{
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 6,
      padding: featured ? '14px 14px 16px' : '12px 12px 14px',
      background: featured
        ? `linear-gradient(180deg, ${item.accent}18 0%, rgba(6,11,20,0.98) 72%)`
        : 'linear-gradient(180deg, rgba(10,17,32,0.95) 0%, rgba(2,5,8,0.98) 100%)',
      border: `1px solid ${featured ? `${item.accent}55` : T.b1}`,
      boxShadow: featured ? `0 0 24px ${item.accent}22` : 'none',
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        background: `radial-gradient(circle at top left, ${item.accent}1f, transparent 48%)`,
        pointerEvents: 'none',
      }} />
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <span style={{ fontSize: 8, fontFamily: MONO, color: item.accent, fontWeight: 800, letterSpacing: '.16em' }}>
            {item.eyebrow}
          </span>
          <span style={{ color: item.accent, fontSize: 13 }}>{item.icon}</span>
        </div>
        <div style={{ fontSize: featured ? 18 : 14, color: T.t1, fontWeight: 800, marginBottom: 6 }}>
          {item.name}
        </div>
        <div style={{ fontSize: 10, color: T.t3, lineHeight: 1.6, marginBottom: 12 }}>
          {item.blurb}
        </div>
        <div style={{ display: 'grid', gap: 6 }}>
          {item.points.map((point) => (
            <div
              key={point}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 7,
                padding: '7px 8px',
                borderRadius: 3,
                background: featured ? `${item.accent}12` : T.void,
                border: `1px solid ${featured ? `${item.accent}33` : T.b0}`,
              }}
            >
              <div style={{ width: 6, height: 6, borderRadius: '50%', background: item.accent, boxShadow: `0 0 10px ${item.accent}66` }} />
              <span style={{ fontSize: 9, color: T.t2, fontFamily: MONO }}>{point}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function AboutJorvexSlot({ activeModule }) {
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <div style={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 8,
        padding: '16px 14px',
        background: 'linear-gradient(135deg, rgba(34,211,238,0.14) 0%, rgba(74,222,128,0.16) 42%, rgba(251,191,36,0.12) 100%)',
        border: `1px solid ${T.b1}`,
      }}>
        <div style={{
          position: 'absolute',
          right: -30,
          top: -40,
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(74,222,128,0.20), transparent 68%)',
          pointerEvents: 'none',
        }} />
        <div style={{ position: 'relative' }}>
          <div style={{ fontSize: 8, fontFamily: MONO, color: T.t2, letterSpacing: '.18em', fontWeight: 800, marginBottom: 8 }}>
            ABOUT JORVEX
          </div>
          <div style={{ fontSize: 15, color: T.t1, fontWeight: 900, lineHeight: 1.15, marginBottom: 6 }}>
            Kaggle for Datasets, HuggingFace for Models, Jorvex for Data Analysis & Experiments.
          </div>
         
         
        </div>
      </div>

      <div style={{ display: 'grid', gap: 10 }}>
        <div style={{ fontSize: 8, fontFamily: MONO, color: T.t4, letterSpacing: '.16em', padding: '0 2px' }}>
          RESEARCH STACK
        </div>
        <StackCard item={STACK[0]} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '0 4px' }}>
          <div style={{ flex: 1, height: 1, background: 'linear-gradient(90deg, rgba(34,211,238,0.35), rgba(251,191,36,0.18))' }} />
          <span style={{ fontSize: 8, color: '#fbbf24', fontFamily: MONO, letterSpacing: '.18em' }}>+</span>
          <div style={{ flex: 1, height: 1, background: 'linear-gradient(90deg, rgba(251,191,36,0.18), rgba(251,191,36,0.35))' }} />
        </div>

        <StackCard item={STACK[1]} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '0 4px' }}>
          <div style={{ flex: 1, height: 1, background: 'linear-gradient(90deg, rgba(251,191,36,0.35), rgba(74,222,128,0.25))' }} />
          <span style={{ fontSize: 8, color: '#4ade80', fontFamily: MONO, letterSpacing: '.18em' }}>→</span>
          <div style={{ flex: 1, height: 1, background: 'linear-gradient(90deg, rgba(74,222,128,0.25), rgba(74,222,128,0.42))' }} />
        </div>

        <StackCard item={STACK[2]} featured />
      </div>

    </div>
  );
}